import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VBtn,{attrs:{"small":"","icon":"","color":"grey darken-2"},on:{"click":function($event){return _vm.$emit('click')}}},[_c(VIcon,{attrs:{"small":""}},[_vm._v("mdi-trash-can-outline")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }